import React, { FunctionComponent, useEffect, useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import Header from '../../components/PageHeader/Header';
import Title from '../../components/PageHeader/Title';
import Loader from '../../components/Loader';
import { DropDownField, MergeTemplate } from '../../store/modules/application/types';
import { MergeQueueHistory } from '../../store/modules/calendar/types';
import PrintDocumentsHistoryInfiniteList from './PrintDocumentsHistoryInfiniteList';
import AutoCompleteSelect from '../../components/AutoCompleteSelect';
type PrintDocumentsProps = {
    getMergeTemplates: Function;
    isLoading: boolean;
    mergeTemplatesList: MergeTemplate[];
    mergeDocuments: Function;
    getPrintDocumentsHistoryList: Function;
    printDocumentsHistoryList: MergeQueueHistory[];
    printDocumentsHistoryLoading: boolean;
    hasMore: boolean;
    documentCount: number;
};
const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        margin: '30px 50px 30px 50px',
        overflow: 'unset !important',
    },
    title: {
        color: '#484848',
        fontSize: 20,
        fontWeight: 500,
        letterSpacing: 0,
    },
    noticeType: {
        display: 'flex',
        margin: '8px',
        fontSize: 14,
        color: theme.palette.text.secondary,
        fontWeight: 500,
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    headerContainer: {
        display: 'flex',
    },
    bodyContainer: {
        display: 'flex',
        padding: '16px !important',
        margin: 100,
        [theme.breakpoints.down('lg')]: {
            margin: '10px',
        },
    },
    selectInput: {
        fontSize: 13,
        border: '1px solid rgb(0,0,0,0.23) !important',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        borderRadius: 3,
        marginBottom: '5px',
        color: '#484848 !important',
    },
    borderedInputs: {
        border: '1px solid #CED4DA',
        padding: 5,
        borderRadius: 4,
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80BDFF',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    width: {
        width: '100%',
    },
    downloadBtnContainer: {
        marginLeft: 10,
        marginTop: 5,
    },
    historyContainer: {
        paddingBottom: 50,
    },
}));
const PrintDocuments: FunctionComponent<PrintDocumentsProps> = (props) => {
    const [selectedTemplate, setSelectedTemplate] = useState<DropDownField | null>(null);
    const [skip, setSkip] = useState<number>(0);
    const limit = 20;
    const {
        getMergeTemplates,
        isLoading,
        mergeTemplatesList,
        mergeDocuments,
        getPrintDocumentsHistoryList,
        printDocumentsHistoryList,
        hasMore,
        documentCount,
    } = props;
    const classes = useStyles();
    const filteredTemplateList = mergeTemplatesList.map((template) => {
        return { label: template.name, value: template.id };
    });
    useEffect(() => {
        const payload = {
            where: {
                type: {
                    nin: ['Event', 'Timesheet'],
                },
            },
            order: ['name ASC'],
            fields: {
                id: true,
                name: true,
            },
        };
        getMergeTemplates(payload);
    }, [getMergeTemplates]);
    useEffect(() => {
        if (selectedTemplate?.value) {
            getPrintDocumentsHistoryList(
                { templateId: selectedTemplate.value },
                {
                    skip: skip,
                    limit,
                },
            );
        }
    }, [getPrintDocumentsHistoryList, selectedTemplate, skip]);
    const handleNoticeTypeChange = (data: DropDownField | null) => {
        setSkip(0);
        setSelectedTemplate(data);
    };
    const handleDownload = () => {
        const selectedTemplateName = filteredTemplateList.find((item) => item.value === selectedTemplate?.value)?.label;
        mergeDocuments(selectedTemplate?.value, selectedTemplateName);
    };
    if (isLoading) return <Loader />;
    return (
        <div className="verticalFillContainer">
            <Header>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Title titleText="Print Documents" />
                </Grid>
            </Header>
            <Card className={classes.root}>
                <CardContent className={classes.headerContainer}>
                    <Typography className={classes.title}>Notification Letters</Typography>
                </CardContent>
                <CardContent className={classes.bodyContainer}>
                    <Grid item xs={4} sm={4} md={4} lg={4} className={classes.noticeType}>
                        <label>Notice Type</label>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4}>
                        <AutoCompleteSelect
                            data={Array.isArray(filteredTemplateList) ? filteredTemplateList : []}
                            value={selectedTemplate}
                            onChange={handleNoticeTypeChange}
                            inputSize={'small'}
                            variant={'outlined'}
                            ariaLabel="Notice Type"
                        />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} className={classes.downloadBtnContainer}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleDownload}
                            disabled={!selectedTemplate}
                        >
                            Download
                        </Button>
                    </Grid>
                </CardContent>
            </Card>

            <div className={`${classes.historyContainer} verticalFillContent`}>
                {selectedTemplate && (
                    <PrintDocumentsHistoryInfiniteList
                        printDocumentsHistoryList={printDocumentsHistoryList}
                        skip={skip}
                        setSkip={setSkip}
                        hasMore={hasMore}
                        documentCount={documentCount}
                        mergeDocuments={mergeDocuments}
                        selectedTemplate={selectedTemplate}
                    />
                )}
            </div>
        </div>
    );
};
export default PrintDocuments;
